import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { INotificationParams } from '../../../app/@types/notification';
import { sentryReport } from '../../../helpers/sentry';
import { showErrorMessage } from '../../../helpers/showMessage';
import { fetchNotifications } from '../../../requests/notifications';

export function useNotificationRequest (
  setNotificationsData: (prevState) => void,
  params: INotificationParams
) {
  const { t } = useTranslation();
  const [hasMoreNotifications, setHasMoreNotifications] =
    useState<boolean>(true);
  const [notificationParams, setNotificationParams] =
    useState<INotificationParams>(params);

  const fetchNextNotificationData = () => {
    const nextPage = notificationParams.page + 1;
    fetchNotifications({ ...notificationParams, page: nextPage })
      .then((response) => {
        setNotificationsData((prevData) => [
          ...(prevData || []),
          ...response.data.results,
        ]);
        setNotificationParams((prevParams) => ({
          ...prevParams,
          page: nextPage,
        }));
        setHasMoreNotifications(nextPage < response.data.numberOfPages);
      })
      .catch((error) => {
        showErrorMessage(
          t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_NOTIFICATIONS')
        );
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_NOTIFICATIONS'),
          path: '/notification',
        });
      });
  };
  return {
    fetchNextNotificationData,
    hasMoreNotifications,
    setNotificationParams,
    setHasMoreNotifications,
    notificationParams,
  };
}
